/* global Hammer,Mustache,site*/
(function ($, prodcat, lazySizes) {
  var isLooksVtoEnabled = Drupal.settings.vto.looks_vto_enabled;
  var isMobileLayout =
    $('html').hasClass('device-mobile') || (Modernizr.touch && $(window).width() < 1024);
  var $siteFooterWrapper = $('.site-footer', document);
  var ELCMacLooksGridOverlay = function ($carouselWrapper, $gridWrapper) {
    var self = this;
    var $targetWrapper;

    self.transitionInProgress = false;
    self.transitionInProgressTimeout;
    self.$originalCarouselParent;
    self.$carouselWrapper = $carouselWrapper;
    self.$gridWrapper = $gridWrapper;
    self.$grid = self.$gridWrapper.find('.js-looks-destination-grid');
    self.$articles = self.$gridWrapper.find('.js-looks-destination-article');
    self.$carousel = $carouselWrapper.find('.js-looks-destination-grid-carousel');
    self.$renderedOverlaysContainer = self.$gridWrapper
      .closest('.js-looks-destination-page-formatter--v1')
      .find('.js-looks-destination-rendered-article');
    self.pagination = {
      oldIndex: 0,
      currentPage: 0,
      $wrapper: $carouselWrapper.find('.js-looks-destination-grid-pagination'),
      $currentPage: $carouselWrapper.find('.js-looks-destination-grid-pagination-current'),
      $totalPages: $carouselWrapper.find('.js-looks-destination-grid-pagination-total'),
      direction: 'forward',
      $previewThumbnails: $carouselWrapper.find('.js-looks-destination-grid-pagination--thumbnail')
    };
    $targetWrapper = isMobileLayout ? $(document) : self.$carouselWrapper;

    if (isMobileLayout) {
      if (!$('body').children('.js-looks-destination-generated-article-pages').length) {
        $('body').append(
          '<div class="js-looks-destination-generated-article-pages looks-destination-overlay__generated-article-pages"></div>'
        );
      }
      self.$renderedOverlaysContainer = $('body').children(
        '.js-looks-destination-generated-article-pages'
      );
    }
    self.$gridWrapper
      .off('ELCMacLooksGridOverlayArticle.launch')
      .on('ELCMacLooksGridOverlayArticle.launch', function (event, $article) {
        self.pagination.currentPage = $article.index();
        self.$article = $article;
        requestAnimationFrame(function () {
          self.$carouselWrapper.addClass('ready');
          self.launch();
          requestAnimationFrame(function () {
            self.$carouselWrapper.addClass('active');
          });
        });
      });

    $(window)
      .off('keydown.looksDestinationFixTop')
      .on('keydown.looksDestinationFixTop', function (event) {
        if (event.key === 'Escape') {
          $('*').scrollTop(0);
          event.stopPropagation();
          self.closeArticleView();
        }
      });
    $targetWrapper.off('keydown.article').on(
      'keydown.article',
      _.throttle(function (event) {
        if (self.transitionInProgress) {
          return false;
        }
        event.stopPropagation();
        if (event.key === 'Escape') {
          self.closeArticleView();
        } else if (event.key === 'ArrowRight') {
          self.pagination.direction = 'forward';
          self.goToNextArticle();
        } else if (event.key === 'ArrowLeft') {
          self.pagination.direction = 'backward';
          self.goToPreviousArticle();
        }
      }, 100)
    );
    $targetWrapper
      .off('click.close')
      .on('click.close', '.js-looks-destination-grid-article-carousel-close', function () {
        self.closeArticleView();
        self.analyticsEvtLink({
          event_name: 'maclooks',
          event_category: 'looks destination',
          event_action: 'navigation buttons',
          event_label: 'close'
        });
      });
    $targetWrapper
      .off('click.prev')
      .on('click.prev', '.js-looks-destination-grid-article-carousel-previous', function () {
        if (self.transitionInProgress) {
          return false;
        }
        self.pagination.direction = 'backward';
        self.goToPreviousArticle();
      });
    $targetWrapper
      .off('click.next')
      .on('click.next', '.js-looks-destination-grid-article-carousel-next', function () {
        if (self.transitionInProgress) {
          return false;
        }
        self.pagination.direction = 'forward';
        self.goToNextArticle();
      });
  };

  ELCMacLooksGridOverlay.prototype.get$article = function () {
    return this.$articles.eq(this.pagination.currentPage);
  };
  ELCMacLooksGridOverlay.prototype.get$articleSlide = function () {
    return this.$carousel.children().eq(this.pagination.currentPage);
  };
  ELCMacLooksGridOverlay.prototype.get$previousArticleOverlay = function () {
    return this.$renderedOverlaysContainer.children().length > 1
      ? this.$renderedOverlaysContainer.children().slice(0, -1)
      : $();
  };
  ELCMacLooksGridOverlay.prototype.get$nextArticleOverlay = function () {
    return this.$renderedOverlaysContainer.children().last();
  };
  ELCMacLooksGridOverlay.prototype.get$nextSlide = function () {
    return this.$carousel.children().eq(this.pagination.currentPage);
  };

  ELCMacLooksGridOverlay.prototype.getNextThumbnailIndex = function () {
    var self = this;
    var currentThumbIndex = self.pagination.currentPage;
    var nextThumbnailIndex =
      currentThumbIndex + 1 === self.pagination.$previewThumbnails.length
        ? 0
        : currentThumbIndex + 1;

    if (self.pagination.direction === 'backwards') {
      var nextThumbnailIndex =
        currentThumbIndex === 0
          ? self.pagination.$previewThumbnails.length - 2
          : currentThumbIndex - 1;
    }
    return nextThumbnailIndex;
  };

  ELCMacLooksGridOverlay.prototype.get$previousSlide = function () {
    var isPreviousSlide = this.pagination.oldIndex !== this.pagination.currentPage;

    return isPreviousSlide ? this.$carousel.children().eq(this.pagination.oldIndex) : $();
  };

  ELCMacLooksGridOverlay.prototype.renderPagination = function () {
    var self = this;
    if (
      !isMobileLayout &&
      $siteFooterWrapper.find('.is-sticky').length > 0 &&
      $siteFooterWrapper.find('.trustmark-logo').length > 0
    ) {
      self.pagination.$wrapper.css({ left: '20px' });
    }
    if (!isMobileLayout) {
      self.renderPaginationThumbnails();
    }

    self.pagination.$currentPage.text(self.pagination.currentPage + 1);
    self.pagination.$totalPages.text(self.$articles.length);
  };

  ELCMacLooksGridOverlay.prototype.renderPaginationThumbnails = function () {
    var self = this;
    if (self.transitionInProgress) {
      return false;
    }
    var $activeThumb = self.pagination.$previewThumbnails.filter('.active');
    var nextThumbnailIndex = self.getNextThumbnailIndex();
    var $nextThumbnail = self.pagination.$previewThumbnails.eq(nextThumbnailIndex);
    if ($activeThumb.length > 0) {
      $nextThumbnail.addClass('transition transition--' + self.pagination.direction);
      setTimeout(function () {
        $nextThumbnail.addClass('transition--in-progress');
        setTimeout(function () {
          $nextThumbnail
            .addClass('active')
            .removeClass(
              'transition transition--in-progress transition--' + self.pagination.direction
            );
          $activeThumb.removeClass('active');
        }, 800);
      }, 1);
    } else {
      self.pagination.$previewThumbnails.eq(self.getNextPageNumber()).addClass('active');
    }
  };

  ELCMacLooksGridOverlay.prototype.closeArticleView = function () {
    var self = this;
    var activeGridIndex = self.get$article().closest('.js-looks-destination-grid-wrapper').index();

    if (self.transitionInProgress) {
      return false;
    }
    self.transitionInProgress = true;
    self.transitionInProgressTimeout = setTimeout(function () {
      self.transitionInProgress = false;
    }, 800);
    self.$renderedOverlaysContainer.html('');
    self.$carouselWrapper.remove();
    self.$articles.removeClass('active');
    $(document).trigger('ELCMacLooksGridOverlay.closing');
    $(document).trigger('ELCMacLooksGridOverlay.closed', [
      self.pagination.currentPage,
      activeGridIndex
    ]);
    $(window).off('keydown.looksDestinationFixTop');
    setTimeout(
      function () {
        requestAnimationFrame(function () {
          $('html').removeClass('looks-destination-full-article-view');
        });
      },
      isMobileLayout ? 0 : 100
    );

    return false;
  };

  ELCMacLooksGridOverlay.prototype.getPreviousPageNumber = function () {
    var previousPage = this.pagination.currentPage - 1;

    if (previousPage < 0) {
      previousPage = this.$articles.length - 1;
    }

    return previousPage;
  };

  ELCMacLooksGridOverlay.prototype.getNextPageNumber = function () {
    var nextPage = this.pagination.currentPage + 1;

    if (nextPage + 1 > this.$articles.length) {
      nextPage = 0;
    }

    return nextPage;
  };

  ELCMacLooksGridOverlay.prototype.goToPreviousArticle = function () {
    var self = this;

    if (self.transitionInProgress) {
      return false;
    }
    self.pagination.oldIndex = self.pagination.currentPage;
    self.pagination.currentPage = self.getPreviousPageNumber();
    self._rotateArticleCarouselBackwards();
    self.renderPagination();
    self.analyticsEvtLink({
      event_name: 'maclooks',
      event_category: 'looks destination',
      event_action: 'looks page',
      event_label: 'swipe - backwards'
    });
    $(document).trigger('ELCMacLooksGridOverlay.rotateArticle', [
      self.$articles.eq(self.pagination.currentPage),
      self.$articles.eq(self.pagination.oldIndex)
    ]);
    $(document).trigger('youtubeIframeAPI.loaded');
  };

  ELCMacLooksGridOverlay.prototype.goToNextArticle = function () {
    var self = this;

    if (self.transitionInProgress) {
      return false;
    }
    self.pagination.oldIndex = self.pagination.currentPage;
    self.pagination.currentPage = self.getNextPageNumber();
    self._rotateArticleCarouselForwards();
    self.renderPagination();
    self.analyticsEvtLink({
      event_name: 'maclooks',
      event_category: 'looks destination',
      event_action: 'looks page',
      event_label: 'swipe - forwards'
    });
    $(document).trigger('ELCMacLooksGridOverlay.rotateArticle', [
      self.$articles.eq(self.pagination.currentPage),
      self.$articles.eq(self.pagination.oldIndex)
    ]);
    $(document).trigger('youtubeIframeAPI.loaded');
  };

  ELCMacLooksGridOverlay.prototype.applyTheme = function () {
    var self = this;
    var $overlayInside = self.get$nextArticleOverlay().find('.js-looks-destination-overlay-v1');
    var isDarkTheme = $overlayInside.data('theme') && $overlayInside.data('theme') === 'dark';

    if (isDarkTheme) {
      self.$carouselWrapper.addClass('looks-destination--dark-theme');
    } else {
      self.$carouselWrapper.removeClass('looks-destination--dark-theme');
    }
  };

  ELCMacLooksGridOverlay.prototype.vtoLooks = function () {
    // Youcam overlay enabled
    var $overlayWrapper = $('.js-looks-destination-overlay-v1');
    var $looksVtoButton = $('.js-looks-vto-btn', $overlayWrapper);
    var $ymkModuleContent = $('#YMK-module');
    $looksVtoButton.once().on('click', function (e) {
      e.preventDefault();
      window.YMK.open();
      $ymkModuleContent.removeClass('hidden');
      $('body').addClass('vto-overlay-launched');
      $(document).trigger('openVtoModule');
    });
  };

  ELCMacLooksGridOverlay.prototype.insertArticleIntoCarousel = function () {
    var self = this;
    var $allProducts;
    var template = self.$gridWrapper.find('.js-article-rendered-template').html();
    var allProductIds = [];
    var allSkuIds = [];
    var allProductPositions = [];

    if (isMobileLayout) {
      self.$renderedOverlaysContainer.append(
        Mustache.render(template, {
          frontend_html_output: self.get$article().find('script.js-article-full').html()
        })
      );
      self.handleArticlePullUpToReveal();
    } else {
      self.$renderedOverlaysContainer.append(
        '<div class="js-looks-destination-generated-article-page looks-destination-overlay__generated-article-page">' +
          Mustache.render(template, {
            frontend_html_output: self.get$article().find('script.js-article-full').html()
          }) +
          '</div>'
      );
    }
    self.applyTheme();
    if (isLooksVtoEnabled) {
      self.vtoLooks();
    }

    self.$renderedOverlaysContainer.find('.js-product__link-to-spp').attr('target', '_blank');
    self.$renderedOverlaysContainer
      .find('.js-looks-destination-shop-this-look-cta')
      .text(self.$gridWrapper.attr('data-shop-this-look-translation'));
    // Analytics
    $allProducts = self.get$nextArticleOverlay().find('.js-grid--mpp__item');
    $allProducts.map(function () {
      allProductIds.push($(this).data('product-id'));
      allSkuIds.push($(this).data('sku-base-id'));
      allProductPositions.push($(this).index());
    });
    self.$gridWrapper
      .find('.js-looks-destination-mobile-author-info')
      .html(
        self.get$nextArticleOverlay().find('.js-looks-destination-overlay-artist').html() || ''
      );
    // Load the steps images
    self
      .get$nextArticleOverlay()
      .find('.js-looks-destination-overlay-steps .lazyload')
      .each(function () {
        if (lazySizes && lazySizes.loader) {
          lazySizes.loader.unveil($(this).get(0));
        }
      });
    requestAnimationFrame(function () {
      $(document).trigger('ELCMacLooksGridOverlayReattach', [self.get$nextArticleOverlay()]);
      $(document).trigger('youtubeIframeAPI.loaded');
    });
    self.analyticsEvtView({
      product_impression_list: [
        location.pathname + '/' + self.getCategoryName() + '/' + self.getLookName()
      ],
      product_impression_position: allProductPositions,
      product_impression_id: allProductIds,
      page_url: location.pathname + '/' + self.getCategoryName() + '/' + self.getLookName()
    });
    self.$renderedOverlaysContainer
      .find('.js-looks-destination-overlay-add-all-to-bag')
      .attr('data-sku-base-id', allSkuIds.join(', '));
  };

  ELCMacLooksGridOverlay.prototype.markSlideTransitionInProgress = function () {
    var self = this;

    self.transitionInProgress = true;
    if (self.transitionInProgressTimeout) {
      clearTimeout(self.transitionInProgressTimeout);
    }
    self.transitionInProgressTimeout = setTimeout(function () {
      self.transitionInProgress = false;
    }, 800);
  };

  ELCMacLooksGridOverlay.prototype._rotateArticleCarouselBackwards = function () {
    var self = this;
    var $previousSlide;
    var $nextSlide;
    var $previousArticleOverlay;
    var $nextArticleOverlay;

    if (self.transitionInProgress) {
      return false;
    }
    requestAnimationFrame(function () {
      self.insertArticleIntoCarousel(self.$article);
      self.markSlideTransitionInProgress();
      $previousSlide = self.get$previousSlide();
      $nextSlide = self.get$nextSlide();
      $previousArticleOverlay = self.get$previousArticleOverlay();
      $nextArticleOverlay = self.get$nextArticleOverlay();

      // Set our next slide to the proper position
      self.$carouselWrapper.addClass('direction-backwards');
      self.$renderedOverlaysContainer.addClass('direction-backwards');
      // overlays
      $nextArticleOverlay.addClass('next-overlay-ready');
      $previousArticleOverlay.removeClass('next-overlay-ready').addClass('previous-overlay-ready');

      // slides
      // Set the stage
      if ($previousSlide.length) {
        $previousSlide.css({
          'z-index': '5',
          transform: 'translateX(0)'
        });
        $nextSlide.css({
          'z-index': '6',
          transition: 'transform 0s',
          transform: 'translateX(-100%)'
        });
      }
      // Transition
      setTimeout(function () {
        $nextSlide.addClass('active');
        setTimeout(function () {
          $nextSlide.css({
            transition: 'transform .8s',
            transform: 'translateX(0)'
          });
        }, 10);
      }, 1);

      self.get$article().addClass('active');
      setTimeout(function () {
        $previousArticleOverlay.addClass('active');
        $nextArticleOverlay.addClass('active');
        setTimeout(function () {
          $previousArticleOverlay.addClass('animate');
          $nextArticleOverlay.addClass('animate');
        });
        setTimeout(function () {
          $previousArticleOverlay.remove();
          $nextArticleOverlay.removeClass('animate next-overlay-ready');
          self.$carouselWrapper.removeClass('direction-backwards');
          self.$renderedOverlaysContainer.removeClass('direction-backwards');
          $previousSlide.removeClass('active').attr('style', '');
        }, 900);
      }, 1);
    });
  };

  ELCMacLooksGridOverlay.prototype._rotateArticleCarouselForwards = function (openingAction) {
    var self = this;
    var $previousSlide;
    var $nextSlide;
    var $previousArticleOverlay;
    var $nextArticleOverlay;

    if (self.transitionInProgress) {
      return false;
    }
    requestAnimationFrame(function () {
      self.insertArticleIntoCarousel(self.$article);
      self.markSlideTransitionInProgress();
      $previousSlide = self.get$previousSlide();
      $nextSlide = self.get$nextSlide();
      $previousArticleOverlay = self.get$previousArticleOverlay();
      $nextArticleOverlay = self.get$nextArticleOverlay();
      // Set our next slide to the proper position
      self.$carouselWrapper.addClass('direction-forwards');
      self.$renderedOverlaysContainer.addClass('direction-forwards');

      // overlays
      $nextArticleOverlay.addClass('next-overlay-ready');
      $previousArticleOverlay.removeClass('next-overlay-ready').addClass('previous-overlay-ready');

      // slides
      if (openingAction) {
        $nextSlide
          .css({
            opacity: '0'
          })
          .addClass('launcher');
      }
      if ($previousSlide.length) {
        $previousSlide.css({
          'z-index': '5',
          transform: 'translateX(0)'
        });
        $nextSlide.css({
          'z-index': '6',
          transition: 'transform 0s',
          transform: 'translateX(100%)'
        });
      }
      // Transition
      setTimeout(function () {
        $nextSlide.addClass('active');
        setTimeout(function () {
          $nextSlide.css({
            transition: 'transform .8s',
            transform: 'translateX(0)'
          });
        }, 10);
      }, 1);

      self.get$article().addClass('active');
      setTimeout(function () {
        $previousArticleOverlay.addClass('active');
        $nextArticleOverlay.addClass('active');
        setTimeout(function () {
          $previousArticleOverlay.addClass('animate');
          $nextArticleOverlay.addClass('animate');
        }, 1);
        setTimeout(
          function () {
            $previousArticleOverlay.remove();
            $nextArticleOverlay.removeClass('animate next-overlay-ready');
            self.$carouselWrapper.removeClass('direction-forwards');
            self.$renderedOverlaysContainer.removeClass('direction-forwards');
            $previousSlide.removeClass('active launcher').attr('style', '');
          },
          openingAction ? 100 : 900
        );
      }, 1);
    });
  };

  ELCMacLooksGridOverlay.prototype.handleArticlePullUpToReveal = function () {
    var self = this;
    var $renderedOverlaysContainerInner = self.$renderedOverlaysContainer
      .find('.js-article-rendered-template')
      .last();
    var hammertime = new Hammer(self.$renderedOverlaysContainer[0]);
    var originalTopPosition;
    var topPosition;

    hammertime.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
    hammertime.on('panstart', function () {
      topPosition = parseInt($renderedOverlaysContainerInner.css('transform').split(',')[5]);
      originalTopPosition = topPosition;
    });

    hammertime.on('panend', function () {
      topPosition = parseInt($renderedOverlaysContainerInner.css('transform').split(',')[5]);
      if (originalTopPosition < topPosition) {
        $renderedOverlaysContainerInner.css({
          transition: 'transform .5s',
          transform: 'translateY(' + originalTopPosition + 'px)'
        });

        return false;
      }
      $renderedOverlaysContainerInner.css({
        transition: 'all .5s ease-out',
        transform: 'translate(0)'
      });
      $renderedOverlaysContainerInner.addClass('article-revealed');
      hammertime.destroy();
    });
    self.$renderedOverlaysContainer
      .find('.js-looks-destination-shop-this-look-cta')
      .off('click.reveal')
      .on('click.reveal', function () {
        $renderedOverlaysContainerInner.css({
          transition: 'all .3s ease-out',
          transform: 'translate(0)'
        });
        if (isLooksVtoEnabled) {
          window.YMK.close();
        }
        $renderedOverlaysContainerInner.addClass('article-revealed');
        hammertime.destroy();
      });
  };

  ELCMacLooksGridOverlay.prototype.analyticsEvtLink = function (analyticsObject) {
    if (site && site.track && site.track.evtLink) {
      setTimeout(function () {
        site.track.evtLink(analyticsObject);
      }, 1);
    }
  };

  ELCMacLooksGridOverlay.prototype.analyticsEvtView = function (analyticsObject) {
    if (site && site.track && site.track.evtView) {
      setTimeout(function () {
        site.track.evtView(analyticsObject);
      }, 1);
    }
  };

  ELCMacLooksGridOverlay.prototype.getCategoryName = function () {
    try {
      return this.get$article().closest('.js-looks-destination-grid-wrapper').data('label');
    } catch (e) {
      return '';
    }
  };

  ELCMacLooksGridOverlay.prototype.getLookName = function () {
    try {
      return this.get$nextArticleOverlay()
        .find('.js-looks-destination-overlay-v1')
        .attr('aria-label')
        .trim();
    } catch (e) {
      return '';
    }
  };

  ELCMacLooksGridOverlay.prototype.launch = function () {
    var self = this;

    self.renderPagination();
    self.setupCarouselTouchControls();
    function trackArticleProductGridClick($product) {
      var $allProducts = $product.parent().find('.js-grid--mpp__item');

      try {
        self.analyticsEvtLink({
          event_name: 'maclooks',
          event_category: 'ecommerce',
          event_action: 'product click',
          event_label: 'product click',
          enh_action: 'product_click',
          product_position: [$allProducts.index($product) + 1],
          product_list: [
            location.pathname + '/' + self.getCategoryName() + '/' + self.getLookName()
          ],
          product_id: [$product.data('product-id')]
        });
      } catch (e) {
        console.log(e);
      }
    }

    $(document)
      .off('click.viewSPP')
      .on(
        'click.viewSPP',
        '.js-looks-destination-overlay-products .js-product__link-to-spp',
        function () {
          trackArticleProductGridClick($(this).closest('.js-grid--mpp__item'));
        }
      );

    $(document)
      .off('click.addToBagMacLooks')
      .on(
        'click.addToBagMacLooks',
        '.js-looks-destination-overlay-products .js-product-add-to-bag',
        function () {
          // Track this first before tracking the add to bag
          trackArticleProductGridClick($(this).closest('.js-grid--mpp__item'));
          self.analyticsEvtView({
            enh_action: 'detail',
            product_id: [$(this).data('product-id')]
          });
        }
      );

    self.$renderedOverlaysContainer
      .off('click.back-to-looks')
      .on(
        'click.back-to-looks',
        '.js-looks-destination-template-article-back-to-looks',
        function (event) {
          var $template = $('.js-looks-destination-overlay-v1');
          var $looksCloseSteps = $('.js-looks-destination-tab-trigger-close', $template);
          event.preventDefault();
          if (isMobileLayout) {
            self.$renderedOverlaysContainer.children().removeClass('article-revealed');
            self.$renderedOverlaysContainer.children().css({
              transform: ''
            });
            self.handleArticlePullUpToReveal();
          } else {
            self.closeArticleView();
          }
          if (isLooksVtoEnabled) {
            $looksCloseSteps.trigger('click');
            window.YMK.close();
          }
          self.analyticsEvtLink({
            event_name: 'maclooks',
            event_category: 'looks destination',
            event_action: 'navigation buttons',
            event_label: 'go back'
          });
        }
      );

    requestAnimationFrame(function () {
      var $article = self.get$article();

      setTimeout(
        function () {
          $('html').addClass('looks-destination-full-article-view');
          self._rotateArticleCarouselForwards(true);
          requestAnimationFrame(function () {});
        },
        isMobileLayout ? 1 : 300
      );
      setTimeout(function () {
        $(document).trigger('ELCMacLooksGridOverlay.opened', [$article]);
      }, 1);
      $('html, body').scrollTop(0);
    });
  };

  ELCMacLooksGridOverlay.prototype.setupCarouselTouchControls = function () {
    var self = this;
    var hammertime = new Hammer(self.$carousel[0]);

    hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL });
    hammertime.on('panend', function (e) {
      if (self.transitionInProgress) {
        return false;
      }
      if (e.direction === Hammer.DIRECTION_RIGHT) {
        self.goToPreviousArticle();
      } else if (e.direction === Hammer.DIRECTION_LEFT) {
        self.goToNextArticle();
      } else if (e.direction === Hammer.DIRECTION_DOWN) {
        self.closeArticleView();
      }
    });
  };

  $(document).on('ELCMacLooksGrid.initArticleOverlay', function (event, $article) {
    var $gridWrapper = $article.parents('.js-looks-destination-grid-wrapper');
    var $carouselContainer = $gridWrapper
      .find('.js-looks-destination-grid-article-carousel')
      .clone();

    requestAnimationFrame(function () {
      $gridWrapper.closest('.looks-destination__content').append($carouselContainer);
      new ELCMacLooksGridOverlay($carouselContainer, $gridWrapper);
      $gridWrapper.trigger('ELCMacLooksGridOverlayArticle.launch', [$article]);
    });
  });

  Drupal.behaviors.looksDestinationOverlayV1 = {
    attach: function (context) {
      var self = this;
      var $template = $('.js-looks-destination-overlay-v1', context);
      var $looksTrigger = $('.js-looks-destination-tab-trigger', $template);
      var $closeSteps = $('.js-looks-destination-tab-trigger-close', $template);
      var $looksSteps = $('.js-looks-destination-overlay-steps', $template);
      var $looksProducts = $('.js-looks-destination-overlay-products', $template);

      $looksTrigger.off('click.trigger').on('click.trigger', function (event) {
        event.preventDefault();
        $looksSteps.removeClass('hidden');
        $looksTrigger.addClass('hidden');
        $closeSteps.removeClass('hidden');
        $looksProducts.addClass('hidden');
      });
      $closeSteps.off('click.trigger').on('click.trigger', function (event) {
        event.preventDefault();
        $looksSteps.addClass('hidden');
        $looksTrigger.removeClass('hidden');
        $closeSteps.addClass('hidden');
        $looksProducts.removeClass('hidden');
      });

      $(document)
        .off('ELCMacLooksGridOverlayReattach.overlay')
        .on('ELCMacLooksGridOverlayReattach.overlay', function (event, $context) {
          self.attach($context);
        });
    }
  };
})(jQuery, window.prodcat, window.lazySizes);
